import React from 'react';
import { AdminLayout } from '../components/custom/AdminLayout';
import AdminBundlesPage from './AdminBundlesPage';

function AdminBundlesPageWrapper() {
  return (
    <AdminLayout>
      <AdminBundlesPage />
    </AdminLayout>
  );
}

export default AdminBundlesPageWrapper;
